/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchTimecardEditChangeProposalsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {SearchTimecardEditChangeProposalsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const searchTimecardEditChangeProposals = (request: SearchTimecardEditChangeProposalsRequest, options?: CashRequestOptions) => post<SearchTimecardEditChangeProposalsRequest, SearchTimecardEditChangeProposalsResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/SearchTimecardEditChangeProposals", request, {...options, rejectOnError: true })